// Native
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router"
import { Box, Flex, Spinner, Text } from "@chakra-ui/react"

// Custom
import { UI } from "components"

export default function Remote(){

    const navigate = useNavigate()
    const params = useLocation()
    const search = new URLSearchParams(params.search)
    const token = search.get('token')

    const handleCheckToken = () => {
        if(!token?.length) navigate('/')
        
        // Limpa o cache local
        localStorage.clear()

        // Registra o novo token
        localStorage.setItem('@token', token)

        setTimeout(() => {
            navigate('/')
            window.location.reload()
        }, 2000)
    }

    useEffect(() => {
        handleCheckToken()
    }, [])

    return(
    <Flex w="100%" h="100vh" alignItems="center" justifyContent="center">

        <Box maxW="300px" p={6} borderWidth={1} borderRadius={4} borderStyle="dotted" textAlign="center" >
            <UI.Lottie animation="remote" style={{ width: 100, transform: 'scale(2)' }} options={{ loop: true }} />
            <Text fontWeight="bold">Abrindo acesso remoto...</Text>
            <Text fontSize="sm" color="GrayText">Esta sessão está sendo monitorada, utilize apenas para fins de suporte.</Text>
            <Spinner mt={4} />
        </Box>

    </Flex>
    )
}